export const ThumbaCoin = ({ className }: { className?: string }) => {
  return <img alt="thumba-coin" src="/assets/vote-ticket.svg" className={className} />;
};
